import React from 'react';
import styles from './FootballBackground.module.scss';

type FootballBackgroundProps = {
  className?: string;
};

const FootballBackground: React.FC<FootballBackgroundProps> = ({ className = '' }) => {
  const baseCls = `${styles.FootballBackground} ${className}`;
  const bgCls = styles[`FootballBackgroundPattern${36}`];


  return <div className={`${baseCls} ${bgCls}`}></div>;
};

export default FootballBackground;
